import { logEvent } from './analyticsUtils';

const collectionsAnalytics = () => {

  const ANALYTICS_EVENTS = {
    CollectionStarted: 'started_collection',
    CollectionCreated: 'save_collection',
    CollectionUpdated: 'updated_collection',
    CollectionDeleted: 'deleted_collection',
    CollectionItemAdded: 'added_collection_item',
    CollectionItemDeleted: 'deleted_collection_item',
    CollectionBulkItemsAdded: 'added_collection_bulk_items',
  };

  const logCollectionStarted = () => {
    logEvent(ANALYTICS_EVENTS.CollectionStarted);
  };

  const logCollectionCreated = (collectionId, collectionName) => {
    logEvent(ANALYTICS_EVENTS.CollectionCreated,{
      collection_id: collectionId,
      collection_name: collectionName,
    });
  };

  const getCollectionNotes = (collection) => {
    if (
      collection.properties &&
      collection.properties.notes &&
      collection.properties.notes[0] &&
      collection.properties.notes[0].content
    ) {
      return collection.properties.notes[0].content;
    }
    return '';
  };

  const logCollectionUpdated = (collection) => {
    logEvent(ANALYTICS_EVENTS.CollectionUpdated,{
      collection_id: collection.id,
      collection_name: collection.title,
      collection_notes: getCollectionNotes(collection),
    });
  };

  const logCollectionDeleted = (collection) => {
    logEvent(ANALYTICS_EVENTS.CollectionDeleted,{
      collection_id: collection.id,
      collection_name: collection.title,
    });
  };

  const logCollectionItemAdded = (collections, feature) => {
    logEvent(ANALYTICS_EVENTS.CollectionItemAdded,{
      collection_ids: collections.map(collection => collection.id),
      collctions: collections.map(collection => ({
        collection_id: collection.id,
        name: collection.title
      })),
      ugc_id: feature.id,
      ugc_type: feature.properties.type,
    });
  };

  const logCollectionItemDeleted = (collection, feature) => {
    logEvent(ANALYTICS_EVENTS.CollectionItemDeleted,{
      collection_id: collection.id,
      collection_name: collection.name,
      ugc_id: feature.id,
      ugc_type: feature.properties.type
    });
  };

  const logCollectionBulkItemsAdded = (collections, features) => {
    logEvent(ANALYTICS_EVENTS.CollectionBulkItemsAdded,{
      collection_ids: collections.map(collection => collection.id),
      collctions: collections.map(collection => ({
        collection_id: collection.id,
        name: collection.title
      })),
      ugc_ids: features.map(feature => feature.id),
      ugcs: features.map(feature => ({
        ugc_id: feature.id,
        ugc_title: feature.title,
      }))
    });
  };

  return {
    logCollectionStarted,
    logCollectionCreated,
    logCollectionUpdated,
    logCollectionDeleted,
    logCollectionItemAdded,
    logCollectionItemDeleted,
    logCollectionBulkItemsAdded,
  };
};

export default collectionsAnalytics();